import React from 'react';
import { useTranslation } from 'react-i18next';
import MerchantRulesTable from 'Components/MerchantRulesTable';
import useGetRuleColumns from 'Hooks/useGetRuleColumns';
import useLatestDeploy from 'Hooks/query-hooks/useLatestDeploy';

type Props = {
    globalRules: GlobalRulesData;
    merchantRules: MerchantRulesData;
    merchantId: string;
};

const MerchantTable = ({ globalRules, merchantRules, merchantId }: Props) => {
    const { t } = useTranslation();
    const { data, isLoading } = useLatestDeploy();
    const columnNames = useGetRuleColumns({
        columns: [
            {
                Header: () => null,
                id: 'overrideGroup',
                accessor: (d) => {
                    return `${d?.overrideGroup}`;
                },
                disableSortBy: true,
                // these would correspond to values in the group by accessor values
                groupByOrder: {
                    [t('Merchant Overrides')]: 0,
                    [t('Global Rules')]: 1
                }
            },
            'ruleId',
            'inputDescription',
            'conclusion',
            'override',
            'lastModified',
            'status'
        ]
    });

    return (
        <MerchantRulesTable
            deployedVersion={data?.version}
            merchantId={merchantId}
            tableName={`deployed-merchant-table-${merchantId}`}
            globalRules={globalRules}
            merchantRules={merchantRules}
            columnNames={columnNames}
            mode='deployed'
            isLoading={isLoading}
        />
    );
};

export default MerchantTable;
